import {
  DELETE_ORGANIZATION_PLOT_GROUP_COMPARISONS_PATH,
  DELETE_ORGANIZATION_PLOT_GROUPS_PATH,
  DeleteOrganizationPlotGroupComparisonsErrorDto,
  DeleteOrganizationPlotGroupComparisonsRequestPathVariables,
  DeleteOrganizationPlotGroupComparisonsRequestQueryParams,
  DeleteOrganizationPlotGroupComparisonsSuccessDto,
  DeleteOrganizationPlotGroupsErrorDto,
  DeleteOrganizationPlotGroupsRequestPathVariables,
  DeleteOrganizationPlotGroupsRequestQueryParams,
  DeleteOrganizationPlotGroupsSuccessDto,
  GET_ALL_PLOT_LABEL_VALUES_PATH,
  GET_PLOT_LABEL_NAMES_PATH,
  GetAllPlotLabelValuesErrorDto,
  GetAllPlotLabelValuesRequestPathVariables,
  GetAllPlotLabelValuesRequestQueryParams,
  GetAllPlotLabelValuesSuccessDto,
  GetPlotLabelNamesErrorDto,
  GetPlotLabelNamesRequestPathVariables,
  GetPlotLabelNamesRequestQueryParams,
  GetPlotLabelNamesSuccessDto,
  PATCH_ORGANIZATION_PATH,
  PATCH_ORGANIZATION_PLOT_GROUPS_PATH,
  PATCH_ORGANIZATION_SUMMARY_PATH,
  PatchOrganizationErrorDto,
  PatchOrganizationPlotGroupsErrorDto,
  PatchOrganizationPlotGroupsRequestBody,
  PatchOrganizationPlotGroupsRequestPathVariables,
  PatchOrganizationPlotGroupsRequestQueryParams,
  PatchOrganizationPlotGroupsSuccessDto,
  PatchOrganizationRequestBodyData,
  PatchOrganizationRequestPathVariables,
  PatchOrganizationRequestQueryParams,
  PatchOrganizationSuccessDto,
  PatchOrganizationSummaryErrorDto,
  PatchOrganizationSummaryRequestBodyData,
  PatchOrganizationSummaryRequestPathVariables,
  PatchOrganizationSummaryRequestQueryParams,
  PatchOrganizationSummarySuccessDto,
  POST_CO_PILOT_CONFIG_PATH,
  POST_ORGANIZATION_PLOT_GROUP_COMPARISONS_PATH,
  POST_ORGANIZATION_PLOT_GROUPS_PATH,
  POST_ORGANIZATION_SUMMARY_PATH,
  POST_PLOT_LABEL_NAME_PATH,
  POST_PLOT_LABEL_VALUE_PATH,
  PostCoPilotConfigErrorDto,
  PostCoPilotConfigRequestBodyData,
  PostCoPilotConfigRequestPathVariables,
  PostCoPilotConfigRequestQueryParams,
  PostCoPilotConfigSuccessDto,
  PostOrganizationPlotGroupComparisonsErrorDto,
  PostOrganizationPlotGroupComparisonsRequestBodyData,
  PostOrganizationPlotGroupComparisonsRequestPathVariables,
  PostOrganizationPlotGroupComparisonsRequestQueryParams,
  PostOrganizationPlotGroupComparisonsSuccessDto,
  PostOrganizationPlotGroupsErrorDto,
  PostOrganizationPlotGroupsRequestBodyData,
  PostOrganizationPlotGroupsRequestPathVariables,
  PostOrganizationPlotGroupsRequestQueryParams,
  PostOrganizationPlotGroupsSuccessDto,
  PostOrganizationSummaryErrorDto,
  PostOrganizationSummaryRequestBodyData,
  PostOrganizationSummaryRequestPathVariables,
  PostOrganizationSummaryRequestQueryParams,
  PostOrganizationSummarySuccessDto,
  PostPlotLabelNameErrorDto,
  PostPlotLabelNameRequestBodyData,
  PostPlotLabelNameRequestPathVariables,
  PostPlotLabelNameRequestQueryParams,
  PostPlotLabelNameSuccessDto,
  PostPlotLabelValueErrorDto,
  PostPlotLabelValueRequestBodyData,
  PostPlotLabelValueRequestPathVariables,
  PostPlotLabelValueRequestQueryParams,
  PostPlotLabelValueSuccessDto,
} from '@/api/rest/resources/types/organization';

import { useApiDeleteRequest } from '../hooks/useApiDeleteRequest';
import { useApiPatchRequest } from '../hooks/useApiPatchRequest';
import { useApiPostRequest } from '../hooks/useApiPostRequest';
import { buildUseSuspenseGetQuery } from '../utils';

const PLOT_LABEL_NAMES_QUERY_KEY = 'plot-label-names';

export const useGetPlotLabelNames = buildUseSuspenseGetQuery<
  GetPlotLabelNamesRequestPathVariables,
  GetPlotLabelNamesRequestQueryParams,
  GetPlotLabelNamesSuccessDto,
  GetPlotLabelNamesErrorDto
>((params) => [PLOT_LABEL_NAMES_QUERY_KEY, params], GET_PLOT_LABEL_NAMES_PATH);

export const useGetAllPlotLabelValues = buildUseSuspenseGetQuery<
  GetAllPlotLabelValuesRequestPathVariables,
  GetAllPlotLabelValuesRequestQueryParams,
  GetAllPlotLabelValuesSuccessDto,
  GetAllPlotLabelValuesErrorDto
>((params) => [PLOT_LABEL_NAMES_QUERY_KEY, 'values', params], GET_ALL_PLOT_LABEL_VALUES_PATH);

export const usePostPlotGroupComparison = () => {
  return useApiPostRequest<
    PostOrganizationPlotGroupComparisonsRequestPathVariables,
    PostOrganizationPlotGroupComparisonsRequestQueryParams,
    PostOrganizationPlotGroupComparisonsRequestBodyData,
    PostOrganizationPlotGroupComparisonsSuccessDto,
    PostOrganizationPlotGroupComparisonsErrorDto
  >(POST_ORGANIZATION_PLOT_GROUP_COMPARISONS_PATH);
};

export const useDeletePlotGroupComparison = () => {
  return useApiDeleteRequest<
    DeleteOrganizationPlotGroupComparisonsRequestPathVariables,
    DeleteOrganizationPlotGroupComparisonsRequestQueryParams,
    DeleteOrganizationPlotGroupComparisonsSuccessDto,
    DeleteOrganizationPlotGroupComparisonsErrorDto
  >(DELETE_ORGANIZATION_PLOT_GROUP_COMPARISONS_PATH);
};

export const usePostPlotGroup = () => {
  return useApiPostRequest<
    PostOrganizationPlotGroupsRequestPathVariables,
    PostOrganizationPlotGroupsRequestQueryParams,
    PostOrganizationPlotGroupsRequestBodyData,
    PostOrganizationPlotGroupsSuccessDto,
    PostOrganizationPlotGroupsErrorDto
  >(POST_ORGANIZATION_PLOT_GROUPS_PATH);
};

export const usePatchPlotGroup = () => {
  return useApiPatchRequest<
    PatchOrganizationPlotGroupsRequestPathVariables,
    PatchOrganizationPlotGroupsRequestQueryParams,
    PatchOrganizationPlotGroupsRequestBody,
    PatchOrganizationPlotGroupsSuccessDto,
    PatchOrganizationPlotGroupsErrorDto
  >(PATCH_ORGANIZATION_PLOT_GROUPS_PATH);
};

export const useDeletePlotGroup = () => {
  return useApiDeleteRequest<
    DeleteOrganizationPlotGroupsRequestPathVariables,
    DeleteOrganizationPlotGroupsRequestQueryParams,
    DeleteOrganizationPlotGroupsSuccessDto,
    DeleteOrganizationPlotGroupsErrorDto
  >(DELETE_ORGANIZATION_PLOT_GROUPS_PATH);
};

export const usePatchOrganization = () => {
  return useApiPatchRequest<
    PatchOrganizationRequestPathVariables,
    PatchOrganizationRequestQueryParams,
    PatchOrganizationRequestBodyData,
    PatchOrganizationSuccessDto,
    PatchOrganizationErrorDto
  >(PATCH_ORGANIZATION_PATH);
};

export const usePostOrganizationSummary = () => {
  return useApiPostRequest<
    PostOrganizationSummaryRequestPathVariables,
    PostOrganizationSummaryRequestQueryParams,
    PostOrganizationSummaryRequestBodyData,
    PostOrganizationSummarySuccessDto,
    PostOrganizationSummaryErrorDto
  >(POST_ORGANIZATION_SUMMARY_PATH);
};

export const usePatchOrganizationSummary = () => {
  return useApiPatchRequest<
    PatchOrganizationSummaryRequestPathVariables,
    PatchOrganizationSummaryRequestQueryParams,
    PatchOrganizationSummaryRequestBodyData,
    PatchOrganizationSummarySuccessDto,
    PatchOrganizationSummaryErrorDto
  >(PATCH_ORGANIZATION_SUMMARY_PATH);
};

export const usePostCoPilotConfig = () => {
  return useApiPostRequest<
    PostCoPilotConfigRequestPathVariables,
    PostCoPilotConfigRequestQueryParams,
    PostCoPilotConfigRequestBodyData,
    PostCoPilotConfigSuccessDto,
    PostCoPilotConfigErrorDto
  >(POST_CO_PILOT_CONFIG_PATH);
};

export const usePostPlotLabelName = () => {
  return useApiPostRequest<
    PostPlotLabelNameRequestPathVariables,
    PostPlotLabelNameRequestQueryParams,
    PostPlotLabelNameRequestBodyData,
    PostPlotLabelNameSuccessDto,
    PostPlotLabelNameErrorDto
  >(POST_PLOT_LABEL_NAME_PATH);
};

export const usePostPlotLabelValue = () => {
  return useApiPostRequest<
    PostPlotLabelValueRequestPathVariables,
    PostPlotLabelValueRequestQueryParams,
    PostPlotLabelValueRequestBodyData,
    PostPlotLabelValueSuccessDto,
    PostPlotLabelValueErrorDto
  >(POST_PLOT_LABEL_VALUE_PATH);
};
